import { render, staticRenderFns } from "./CalculationBoard.vue?vue&type=template&id=f50b1d72&"
import script from "./CalculationBoard.vue?vue&type=script&lang=js&"
export * from "./CalculationBoard.vue?vue&type=script&lang=js&"
import style0 from "./CalculationBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports